export enum UserRole {
    SYSTEM_ADMIN = 'System Administrator',
    QC_OFFICER = 'Quality Control Officer',
    AUDITOR = 'Auditor',
}
